import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import authGuard from './guards/auth';
import guestGuard from './guards/guest';
import inSetupGuard from './guards/setup';
import twoFactorRequiredGuard from './guards/twoFactorRequired';

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return { el: to.hash, behavior: 'smooth' };
        }
        return { top: 0 };
    }
});

// assign navigation guards
// NB. the order is important

router.beforeResolve(authGuard);
router.beforeResolve(twoFactorRequiredGuard);
router.beforeResolve(guestGuard);
router.beforeResolve(inSetupGuard);

export default router;
